/* Load the consent interface once the age decision has released the storefront. */
(function () {
  var injectorUrl = 'https://tag.goadopt.io/injector.js?website_code=c9905eea-cdba-4165-9b98-7d77d412b4b2';
  var loaded = false;

  function ageConfirmed() {
    return document.cookie.split(';').some(function (part) {
      return part.trim() === 'newsletter-popup=closed';
    });
  }

  function loadConsent() {
    if (loaded) return;
    loaded = true;
    var script = document.createElement('script');
    script.src = injectorUrl;
    script.className = 'adopt-injector';
    document.head.appendChild(script);
  }

  function ready() {
    if (!document.querySelector('#halo-newsletter-popup') || ageConfirmed()) {
      loadConsent();
      return;
    }

    var popup = document.querySelector('#halo-newsletter-popup');
    popup.addEventListener('click', function (event) {
      if (!event.target.closest('[data-close-newsletter-popup]')) return;
      /* The age dialog closes with a short transition. */
      window.setTimeout(loadConsent, 750);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }
})();
